import React, { Fragment } from "react";
import Link from "next/link";
import SectionTitle from "../common/section_title";
import CountyBox from "../common/country_box";
import { getAssets } from "@unisearch/helpers";
import styles from "./styles/home.module.scss";

export const BestCountry = ({ allCountry }) => {
  return (
    <Fragment>
      <section className={styles.best_countries}>
        <div className="container">
          <div className={styles.title_wrapper}>
            <h2 className={styles.title}>
              Explore the Best Study Abroad Destinations
            </h2>
            <p>
              Where do you plan on studying abroad? Turn hours of research into
              minutes by using our intuitive AI-driven search engine to filter
              through all the programs and universities by country, fine-tuned
              to your specific requirements, be it tuition fee ranges, areas of
              specialisation, scholarship availability, and more.
            </p>
          </div>
        </div>

        <div className={styles.countries_area}>
          <div className="container">
            <div className={styles.row}>
              {allCountry.length > 0 &&
                allCountry.map((country, i) => {
                  return (
                    <div key={i}>
                      <CountyBox
                        image={
                          country?.src ||
                          getAssets("assets/images/image_placeholder_big.webp")
                        }
                        // size={`${i === 0 ? "large" : "small"}`}
                        title={country?.name}
                        university={country?.totalUni}
                        courses={country?.totalCourse}
                        countrySlug={country?.slug}
                      />
                    </div>
                  );
                })}
            </div>

            <div className={styles.view_allcountry_btn}>
              <Link legacyBehavior href="/explore-university">
                <a className="btn btn-primary btn-bg">View All Countries</a>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default BestCountry;
